import { ApiRequest } from '../baseService'

const baseRoute = 'app/redaction-review'

/**
 * Human review queue for documents the redaction pipeline held back.
 * Onshore Admin / Admin Staff only — the backend rejects everyone else.
 */

function GetQueue(filter: {
  statuses?: string[]
  priorities?: string[]
  overdueOnly?: boolean
  filterText?: string
  skipCount?: number
  maxResultCount?: number
}) {
  // Repeated keys (Statuses=Open&Statuses=InProgress) is what ASP.NET binds a List<T>
  // from; a comma-joined string silently binds to nothing.
  const params = new URLSearchParams()

  filter.statuses?.forEach(s => params.append('Statuses', s))
  filter.priorities?.forEach(p => params.append('Priorities', p))
  if (filter.overdueOnly) {
    params.append('OverdueOnly', 'true')
  }
  if (filter.filterText) {
    params.append('FilterText', filter.filterText)
  }
  params.append('SkipCount', String(filter.skipCount ?? 0))
  params.append('MaxResultCount', String(filter.maxResultCount ?? 20))

  return ApiRequest.get(`${baseRoute}?${params.toString()}`)
}

/** Both file ids plus every detected entity — powers the side-by-side screen. */
function GetReviewDocument(attachmentId: string) {
  return ApiRequest.get(`${baseRoute}/documents/${attachmentId}`)
}

/** Pipeline health for the strip: counts, verification fail rate, guardrail state. */
function GetHealth() {
  return ApiRequest.get(`${baseRoute}/health`)
}

/** Lifts the guardrail hold on automatic release. Note is mandatory. */
function ResumeAutoRelease(note: string) {
  return ApiRequest.post(`${baseRoute}/resume-auto-release`, { note })
}

/**
 * Rendered page images of the ORIGINAL, with page size in PDF points so the caller
 * can place each detected span's rectangle over the image.
 */
function GetReviewPages(attachmentId: string) {
  return ApiRequest.get(`${baseRoute}/documents/${attachmentId}/pages`)
}

function AssignToMe(taskId: string) {
  return ApiRequest.post(`${baseRoute}/${taskId}/assign-to-me`)
}

/** Closes the task. The note is mandatory — the backend rejects an empty one. */
function Decide(taskId: string, decision: string, note: string) {
  return ApiRequest.post(`${baseRoute}/${taskId}/decision`, { decision, note })
}

/** Keeps or restores one span. Restoring information requires a reason. */
function DecideEntity(entityId: string, action: string, note?: string) {
  return ApiRequest.post(`${baseRoute}/entities/decision`, {
    entityId,
    action,
    note,
  })
}

const API = {
  GetQueue,
  GetHealth,
  ResumeAutoRelease,
  GetReviewPages,
  GetReviewDocument,
  AssignToMe,
  Decide,
  DecideEntity,
}

export default API
